import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950">分类快捷入口</h2>
          <p className="mt-2 text-sm text-foreground-500">按类型快速找到你想看的电视剧</p>
        </div>
        <Link to="/category" className="text-sm text-primary-700 hover:text-primary-600 font-medium inline-flex items-center gap-1 whitespace-nowrap">
          查看全部分类
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${encodeURIComponent(cat.key)}`}
            className="group flex flex-col items-center justify-center gap-2 py-4 md:py-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
          >
            <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-xl`} />
            </span>
            <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700">{cat.label}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}